<template>
	<div class="ptrl-20-16">
		<div class="list_every ptlr-15-20 box-s pb-20 mb-16">
      <div class="fz-15 fw-500 c1 mb-20">
        <div class="l-h-21">对您造成的不便我们深表歉意！</div>
        <div class="l-h-21">为方便我们排查错误，请您详细描述错误</div>
      </div>

      <van-checkbox-group v-model="checked">
        <div class="flexs mb-15">
          <van-checkbox name="含有错别字" shape="square">含有错别字</van-checkbox>
          <van-checkbox name="答案不正确" shape="square">答案不正确</van-checkbox>
          <van-checkbox name="题目不完整" shape="square">题目不完整</van-checkbox>
        </div>

        <div class="flexs">
          <van-checkbox name="图片不显示" shape="square">图片不显示</van-checkbox>
          <van-checkbox name="解析不完整" shape="square">解析不完整</van-checkbox>
          <van-checkbox name="其他" shape="square">音频没法播</van-checkbox>
        </div>
      </van-checkbox-group>
    </div>
    <div class="list_every pd-15 box-s">
      <textarea name="" v-model="description" id="" cols="30" rows="10" placeholder="其他错误，请详细描述您遇到的问题…"></textarea>
    </div>


    <div class="btn_contain">
      <div class="blue_btn" @click="submit">
        提交
      </div>
    </div>
	</div>

</template>
<script>
	import { errorFeedback } from '@/api/api.js'
	export default {
		components: {

		},
		data() {
			return {
        checked: [],
        description: ''
			};
		},
		created() {

		},
		methods: {
		  async submit(){
        //const res = await errorFeedback({ question_id: this.$route.query.question_id, feedback_type: this.checked.length == 0? '':(this.checked.length == 1? `${this.checked}`: this.checked.join(',')), description: this.description})
        //记录错题反馈时候的答案
        let model_id = 0;
        if(this.$route.query.type == 'history'){
          model_id = this.$route.query.answer_id
        } else if(this.$route.query.type == 'text'){
          model_id = this.$route.query.examination_id
        } else if(this.$route.query.type == 'random'){
          model_id = this.$route.query.question_id
        } else if(this.$route.query.type == 'pass'){
          model_id = this.$route.query.gate_level_user_id
        } else if(this.$route.query.type == 'wrong'){
          model_id = this.$route.query.question_id
        } else if(this.$route.query.type == 'imit'){
          model_id = this.$route.query.practice_exam_user_id
        } else if(this.$route.query.type == 'mide'){
          model_id = this.$route.query.answer_id
        } else if(this.$route.query.type == 'practice'){
          model_id = this.$route.query.dailyStudyId
        }
        const res = await errorFeedback({ question_id: this.$route.query.question_id, feedback_type: this.checked.length == 0? '':(this.checked.length == 1? `${this.checked}`: this.checked.join(',')), description: this.description,model_id: model_id,type:this.$route.query.type})
        if(res.code == 1000){
          this.$toast.success('提交成功')
          setTimeout(() => {
            if(this.$route.query.type == 'history'){

              this.$router.replace({ path: '/historyanalysis', query: {answer_id: this.$route.query.answer_id, qusetNum: this.$route.query.qusetNum  } })
            } else if(this.$route.query.type == 'text'){

              this.$router.replace({ path: '/testquesttxt', query: { examination_id: this.$route.query.examination_id,  qusetNum: this.$route.query.qusetNum  } })
            } else if(this.$route.query.type == 'random'){

              this.$router.replace({ path: '/randomstartquest', query: { subject_id: this.$route.query.subject_id, length: this.$route.query.length, random_learn_question_id: this.$route.query.random_learn_question_id,typeNl: this.$route.query.typeNl  } })
            } else if(this.$route.query.type == 'pass'){

              this.$router.replace({ path: '/passanalysis', query: { qusetNum: this.$route.query.qusetNum, gate_level_user_id: this.$route.query.gate_level_user_id  } })
            } else if(this.$route.query.type == 'wrong'){

              this.$router.replace({ path: '/wrongquest', query: { qusetNum: this.$route.query.qusetNum, subject_id: this.$route.query.subject_id  } })
            } else if(this.$route.query.type == 'imit'){

              this.$router.replace({ path: '/imitAnalysis', query: { qusetNum: this.$route.query.qusetNum, practice_exam_user_id: this.$route.query.practice_exam_user_id  } })
            } else if(this.$route.query.type == 'mide'){

              this.$router.replace({ path: '/mideAnalysis', query: { qusetNum: this.$route.query.qusetNum, answer_id: this.$route.query.answer_id  } })
            } else if(this.$route.query.type == 'practice'){

              this.$router.replace({ path: '/analysis', query: { qusetNum: this.$route.query.qusetNum, dailyStudyId: this.$route.query.dailyStudyId  } })
            }
            
          }, 500);
        } else {
            this.$toast(res.msg)
          }
      }
		}
	}
</script>
<style lang="less" scoped>
/deep/.van-checkbox__icon .van-icon {
  position: relative;
  width: 16px;
  height: 16px;
}

/deep/.van-icon-success::before {
  position: absolute;
  left: -1px;
  top: -1px;
}

/deep/.van-checkbox__label {
  margin-left: 5px ;
}

/deep/.van-checkbox {
  flex: 1;
}

textarea {
  width: 100%;
  height: 100%;
  font-size: 13px;
  line-height: 18px;
  color: #333;
}
</style>
